import { Button, Tooltip } from "@dit/core-frontend"
import { Box } from "@mos-cat/ds"
import React, { memo } from "react"
import { buttonProps } from "./buttonProps"
import { FORMAT_TEXT_COMMAND } from "lexical"

export const TextStyleButtons = memo(
  ({ activeEditor, isEditable, isBold, isItalic, isUnderline, styles, blockType }) => {
    return (
      <Box display="flex" alignItems="center" gridGap="10px">
        <Tooltip content="Применение полужирного начертания к тексту">
          <Button
            {...buttonProps}
            kind="borderless"
            disabled={!isEditable || blockType === "h3"}
            onClick={() => {
              activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold")
            }}
            className={`${styles.boldBtn} ` + (isBold ? ` ${styles.active}` : "")}
          >
            <span>B</span>
          </Button>
        </Tooltip>
        <Tooltip content="Применение курсивного начертания к тексту">
          <Button
            {...buttonProps}
            kind="borderless"
            disabled={!isEditable}
            onClick={() => {
              activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic")
            }}
            className={`${styles.italicBtn} ` + (isItalic ? ` ${styles.active}` : "")}
          >
            <span>I</span>
          </Button>
        </Tooltip>
        <Tooltip content="Подчеркивание текста">
          <Button
            {...buttonProps}
            kind="borderless"
            disabled={!isEditable}
            onClick={() => {
              activeEditor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline")
            }}
            className={`${styles.underLineBtn} ` + (isUnderline ? ` ${styles.active}` : "")}
          >
            <span>U</span>
          </Button>
        </Tooltip>
      </Box>
    )
  },
)
TextStyleButtons.displayName = "TextStyleButtons"
